import { ShareResourceEnum } from 'modules/share/enum/share-resource-enum'

export const getResourceApiSlug = (
  type?: ShareResourceEnum,
):
  | ShareResourceEnum.Blog
  | ShareResourceEnum.Funnel
  | ShareResourceEnum.Newsletter
  | ShareResourceEnum.Campaign
  | ShareResourceEnum.Course
  | ShareResourceEnum.UserBlock
  | ShareResourceEnum.MasterBlock
  | ShareResourceEnum.Workflow
  | undefined => {
  switch (type) {
    case ShareResourceEnum['share-funnel']:
      return ShareResourceEnum.Funnel
    case ShareResourceEnum['share-blog']:
      return ShareResourceEnum.Blog
    case ShareResourceEnum['share-newsletter']:
      return ShareResourceEnum.Newsletter
    case ShareResourceEnum['share-campaign']:
      return ShareResourceEnum.Campaign
    case ShareResourceEnum['share-course']:
      return ShareResourceEnum.Course
    default:
      return type
  }
}
